import 'widget/widget.scss'

import 'tiny-slider/src/tiny-slider.scss'
import { tns } from 'tiny-slider/src/tiny-slider.js'

const sliderCallback = () => {
  if(document.querySelector(".my-slider")) {
    tns({
      container: '.my-slider',
      navContainer: '#custom-nav-slider',
      items: 1,
      gutter: 0,
      slideBy: 'page',
      speed: 1000,
      swipAngle: false,
      controls: false,
      axis: "horizontal",
      swipeAngle: false,
      mouseDrag: true,
      autoplay: true,
      autoplayButtonOutput: false,
      //IMPORTANT: Does mess with mouseDrag
      //autoplayHoverPause: true,
      autoplayTimeout: 7000,
    });
  }
}
document.addEventListener("DOMContentLoaded", sliderCallback )
